var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"bridging-news"},[_c('div',{staticClass:"bridging"},[_c('Header')],1),_c('div',{staticClass:"home-bg isLoaded"},[_c('HomeBg'),_c('TopContent'),_c('Slide')],1)]),_c('WorldMap'),_c('RiskDeploy'),_c('CardSolution'),_c('div',{staticClass:"wrapper"},[_c('SupportCarousel')],1),_c('Crypto'),(false)?_c('RegisterStep'):_vm._e(),_c('LearnMore'),_c('div',{style:({
      marginTop: '100px',
    })},[_c('Footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }